module.exports = __webpack_public_path__ + "static/media/logo-dream-turk-93x93px.b88b5aa5.png";